import { IArtifacts } from "../../model/IArtifacts"

export const ArtifactsObject: IArtifacts = {
    Url: '',
    htUrl: '',
    htParam: '',
    htId: '',
    EnvironmentCode: '',
    hosturl: '',
}

export const PaymentFormDataObject = {
    CCType: { id: '', name: '', code: '' },
    CCNum: '',
    ExpMo: '',
    ExpYr: '',
    CVV: '',
    Payor: '',
    HfResponseCode: '',
    HfDataKey: '',
    HfErrorMessage: '',
    Artifacts: ArtifactsObject
}